import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {GlobalSearchResultApiModel} from '../models/global-search-result.api.model';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchRestService {
  private readonly resource = '/search/global';

  constructor(
    private readonly http: HttpClient,
    private readonly translateService: TranslateService
  ) {
  }

  public search(params: {
    q: string;
    limit?: number;
    offset?: number;
    types?: string[];
    groupByType?: boolean;
    highlight?: boolean;
    forceRefresh?: boolean;
    exactTag?: string | null;
  }): Observable<GlobalSearchResultApiModel> {
    let httpParams = new HttpParams().set('q', params.q || '');

    if (typeof params.limit === 'number') {
      httpParams = httpParams.set('limit', String(params.limit));
    }
    if (typeof params.offset === 'number') {
      httpParams = httpParams.set('offset', String(params.offset));
    }
    if (typeof params.groupByType === 'boolean') {
      httpParams = httpParams.set('groupByType', String(params.groupByType));
    }
    if (typeof params.highlight === 'boolean') {
      httpParams = httpParams.set('highlight', String(params.highlight));
    }
    if (this.translateService.currentLang) {
      httpParams = httpParams.set('locale', this.translateService.currentLang);
    }
    if (params.forceRefresh) {
      httpParams = httpParams.set('_ts', String(Date.now()));
    }
    if (params.exactTag) {
      httpParams = httpParams.set('exactTag', params.exactTag);
    }

    (params.types || []).forEach((type) => {
      httpParams = httpParams.append('type[]', type);
    });

    return this.http.get<GlobalSearchResultApiModel>(environment.apiUrl + this.resource, {params: httpParams});
  }
}
